import React, { useState, useEffect, useRef } from "react";
import "./UserCoursePlayer.css";
import { useLocation, useNavigate } from "react-router-dom";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import CourseSections from "../../../components/UserPanel/UserCoursePlayer/CourseSections/CourseSections";
import CourseLesson from "../../../components/UserPanel/UserCoursePlayer/CourseLesson/CourseLesson";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import LoadingButton from "@mui/lab/LoadingButton";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FormLabel from "@mui/material/FormLabel";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import Replay5Icon from "@mui/icons-material/Replay5";
import Replay10Icon from "@mui/icons-material/Replay10";
import Replay30Icon from "@mui/icons-material/Replay30";
import Forward10Icon from "@mui/icons-material/Forward10";
import TextField from "@mui/material/TextField";
import axios from "axios";
import LongText from "../../../components/LongText/LongText";
import { Rating } from "@mui/material";
import ReactToPrint from "react-to-print";
import { PDFToPrint } from "../../Course/PDFToPrint";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const UserCoursePlayer = () => {
  const videoRef = useRef();
  const PDFRef = useRef();

  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);

  let { state } = useLocation();
  let navigate = useNavigate();
  const [courseData, setCourseData] = useState();
  const [enrollCourseData, setEnrollCourseData] = useState();

  const [loading, setLoading] = useState(true);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [nextBtn, setNextBtn] = useState(false);
  const [quizBtn, setQuizBtn] = useState(false);
  const [open, setOpen] = useState(false);
  const [openCertificateModal, setOpenCertificateModal] = useState(false);
  const [openResult, setOpenResult] = useState(false);
  const [playing, setPlaying] = useState(false);
  const [pause, setPause] = useState(false);

  const [firstTime, setFirstTime] = useState(true);
  const [fullScreen, setFullScreen] = useState(false);
  const [sectionIndex, setSectionIndex] = useState(0);
  const [lessonIndex, setLessonIndex] = useState(0);

  const [quizValue, setQuizValue] = useState([]);
  const [quizResult, setQuizResult] = useState();
  const [score, setScore] = useState();
  const [maxScore, setMaxScore] = useState();
  const [grade, setGrade] = useState();
  const [ratings, setRatings] = useState(0);
  const [feedback, setFeedback] = useState("");
  const [completed, setCompleted] = useState(false);
  const [completedData, setCompletedData] = useState(null);
  const [rated, setRated] = useState(false);
  const [timerRun, setTimerRun] = useState(false);

  const [minute, setMinute] = useState(null);
  const [second, setSecond] = useState(null);

  const [indQuiz, setIndQuiz] = useState(null);
  const [shownQuizTimes, setShownQuizTimes] = useState([]);

  // true = during-video quiz popup, false = post-video quiz popup
  const [indQuizToggler, setIndQuizToggler] = useState(false);
  const [questionsArr, setQuestionsArr] = useState([]);

  const hasWindow = typeof window !== "undefined";
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  function getWindowDimensions() {
    const width = hasWindow ? window.innerWidth : null;
    return { width };
  }

  useEffect(() => {
    if (hasWindow) {
      function handleResize() {
        setWindowDimensions(getWindowDimensions());
      }
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }
  }, [hasWindow]);

  // ─── Reset shown quizzes when lesson changes ───────────────────────────────
  useEffect(() => {
    setShownQuizTimes([]);
    setQuizValue([]);
    setIndQuizToggler(false);
    setIndQuiz(null);
    setOpenResult(false);
    setNextBtn(false);
    setQuizBtn(false);
  }, [sectionIndex, lessonIndex]);

  // ─── Fullscreen helpers ────────────────────────────────────────────────────
  const exitFullScreen = () => {
    if (
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement
    ) {
      if (document.exitFullscreen) document.exitFullscreen();
      else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
      else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
      else if (document.msExitFullscreen) document.msExitFullscreen();
    }
  };

  const openFullScreen = () => {
    setFullScreen(!fullScreen);
    const elem = videoRef.current;
    if (fullScreen === true) {
      if (elem.requestExitFullscreen) elem.requestExitFullscreen();
      else if (elem.mozCancelFullscreen) elem.mozCancelFullscreen();
      else if (elem.webkitExitFullscreen) elem.webkitExitFullscreen();
      else if (elem.exitFullscreen) elem.exitFullscreen();
    } else {
      if (elem.requestFullscreen) elem.requestFullscreen();
      else if (elem.mozRequestFullScreen) elem.mozRequestFullScreen();
      else if (elem.webkitRequestFullscreen) elem.webkitRequestFullscreen();
      else if (elem.msRequestFullscreen) elem.msRequestFullscreen();
    }
  };

  const handleBackward = (sec) => {
    if (videoRef.current) {
      videoRef.current.currentTime -= sec;
      setCurrentTime(videoRef.current.currentTime);
    }
  };

  const handleForward = (sec) => {
    if (videoRef.current) {
      videoRef.current.currentTime += sec;
      setCurrentTime(videoRef.current.currentTime);
    }
  };

  // ─── Quiz answer selection ─────────────────────────────────────────────────
  const handleQuizChange = (e, ind, cur) => {
    if (cur?.isDuringVideo) {
      setIndQuiz({ value: e.target.value, question: cur });
    }
    setQuizValue((prev) => prev.filter((item) => item?.question !== cur.question));
    setQuizValue((prev) => [
      ...prev,
      {
        question: cur?.question,
        correctAnswer: cur?.correctAnswer,
        myAnswer: e.target.value,
      },
    ]);
  };

  // ─── POST-VIDEO quiz submit ────────────────────────────────────────────────
  // Validates against questionsArr.length (the currently shown questions),
  // NOT lessonQuiz.length (which includes during-video questions too).
  const handleQuizSubmit = () => {
    // Only count answers for questions in the current questionsArr
    const answeredForCurrentQuestions = quizValue.filter((v) =>
      questionsArr.some((q) => q.question === v.question)
    );

    if (answeredForCurrentQuestions.length < questionsArr.length) {
      toast.warn("Please Solve all Questions");
      return;
    }

    const ans = answeredForCurrentQuestions.filter(
      (item) => item.correctAnswer === item.myAnswer
    );
    setMaxScore(questionsArr.length);
    setScore(ans.length);
    const per = (ans.length / questionsArr.length) * 100;
    setQuizResult(per);
    setLoadingBtn(true);

    const scoreBody = {
      token: localStorage.getItem("token"),
      enrollmentID: enrollCourseData._id,
      score: ans.length,
      maxScore:
        !enrollCourseData.completed &&
        sectionIndex >= enrollCourseData.sectionIndex &&
        lessonIndex >= enrollCourseData.lessonIndex
          ? ans.length
          : 0,
    };

    axios
      .post(process.env.REACT_APP_BACKEND_URL + "/api/enrollment/score", scoreBody)
      .then((res) => {
        if (res.data.error !== true) {
          toast.success(res.data.message);
          if (res.data.data.completed) {
            setCompletedData(res.data.data);
            setRatings(res?.data?.data?.rating);
            setFeedback(res?.data?.data?.feedback);
            setCompleted(true);
            setRated(true);
          }
          setLoadingBtn(false);
          // Show result inside the modal — do NOT close or resume video here
          setOpenResult(true);
        } else {
          toast.warn(res.data.message);
          setLoadingBtn(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoadingBtn(false);
      });

    setNextBtn(true);
  };

  // ─── DURING-VIDEO quiz submit ──────────────────────────────────────────────
  const handleIndQuizSubmit = () => {
    if (quizValue.filter((v) => questionsArr.some((q) => q.question === v.question)).length < questionsArr.length) {
      toast.warn("Please answer the question before continuing");
      return;
    }

    // If correct answer, skip forward 1 sec past the quiz point
    if (indQuiz?.value === indQuiz?.question?.correctAnswer) {
      handleForward(1);
    }

    // Mark these questions as seen so they never retrigger
    setShownQuizTimes((prev) => [...prev, ...questionsArr.map((q) => q.question)]);

    // Resume video
    setOpen(false);
    setIndQuizToggler(false);
    setIndQuiz(null);
    setPlaying(true);
    setPause(false);
    setFullScreen(false);
    if (videoRef.current) {
      videoRef.current.play();
    }
  };

  // ─── During-video quiz trigger (currentTime watch) ─────────────────────────
  // Parses "0 hour(s) 1 minute(s) 0 second(s)" and checks ±1s tolerance
  const parseQuizTime = (time) => {
    if (!time) return null;
    const match = time.match(
      /(?:(\d+) hour\(s\)\s*)?(?:(\d+) minute\(s\)\s*)?(?:(\d+) second\(s\))?/
    );
    if (!match) return null;
    const hours = parseInt(match[1] || 0);
    const minutes = parseInt(match[2] || 0);
    const seconds = parseInt(match[3] || 0);
    return hours * 3600 + minutes * 60 + seconds;
  };

  const test = (time) => {
    const quizTimeInSec = parseQuizTime(time);
    if (quizTimeInSec === null) return false;
    return Math.abs(currentTime - quizTimeInSec) <= 1;
  };

  useEffect(() => {
    if (!courseData || open) return;

    const lesson = courseData.courseContent[sectionIndex].sectionLessons[lessonIndex];

    const questionArr = lesson.lessonQuiz.filter(
      (item) =>
        item.isDuringVideo &&
        test(item.quizTime) &&
        !shownQuizTimes.includes(item.question)
    );

    if (questionArr.length > 0) {
      // Only show questions not already correctly answered
      const filteredArr = questionArr.filter(
        (item) =>
          !quizValue.some(
            (ele) => ele.question === item.question && ele.correctAnswer === ele.myAnswer
          )
      );

      if (filteredArr.length > 0) {
        setQuestionsArr(filteredArr);
        setIndQuizToggler(true); // <-- mark as during-video quiz

        exitFullScreen();
        setOpen(true);
        setPlaying(false);
        setPause(true);
        videoRef.current.pause();
        setFullScreen(false);

        // Mark as shown immediately to prevent re-trigger during the ±1s window
        setShownQuizTimes((prev) => [...prev, ...filteredArr.map((q) => q.question)]);
      }
    }
  }, [currentTime, courseData, sectionIndex, lessonIndex]);
  // Note: intentionally NOT including quizValue or shownQuizTimes in deps
  // to avoid infinite loop — they are read as latest via closure on each tick

  // ─── Video ended: show post-video quiz ────────────────────────────────────
  const handleVideoEnded = () => {
    exitFullScreen();
    const lesson = courseData.courseContent[sectionIndex].sectionLessons[lessonIndex];

    const isLastLesson =
      sectionIndex + 1 >= courseData.courseContent.length &&
      lessonIndex + 1 >= courseData.courseContent[sectionIndex].sectionLessons.length;
      
    const postVideoQuiz = lesson.lessonQuiz.filter(
      (q) => !q.isDuringVideo && !shownQuizTimes.includes(q.question)
    );

    if (postVideoQuiz.length > 0) {
      setQuestionsArr(postVideoQuiz);
      setIndQuizToggler(false); // <-- mark as post-video quiz
      setOpen(true);
      setQuizBtn(true);
      setPlaying(false);
      setFullScreen(false);
      if (videoRef.current) videoRef.current.pause();

      setShownQuizTimes((prev) => [...prev, ...postVideoQuiz.map((q) => q.question)]);
    }  else if (isLastLesson) {
    // No quiz but last lesson — open modal just for rating
    setQuestionsArr([]);
    setIndQuizToggler(false);
    setOpenResult(true); // go straight to result/rating screen
    setOpen(true);
    setQuizBtn(true);
    setPlaying(false);
  }
    else {
      setNextBtn(true);
    }
  };

  // ─── API / data fetching ───────────────────────────────────────────────────
  const getSingleEnrolled = () => {
    setLoading(true);
    axios
      .post(process.env.REACT_APP_BACKEND_URL + "/api/enrollment/getSingleEnrolled", {
        token: localStorage.getItem("token"),
        courseID: state.id,
      })
      .then((res) => {
        setCourseData(res.data.course);
        setEnrollCourseData(res.data.data);
        setSecond(res.data.data.second ? res.data.data.second : 0);
        setMinute(res.data.data.minute ? res.data.data.minute : 0);
        setSectionIndex(res.data.data.sectionIndex);
        setLessonIndex(res.data.data.lessonIndex);
        setLoading(false);
        setPlaying(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    getSingleEnrolled();
  }, []);

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
  };

  const getGrade = () => {
    axios
      .post(process.env.REACT_APP_BACKEND_URL + "/api/enrollment/getGrade", {
        token: localStorage.getItem("token"),
        enrollmentID: enrollCourseData?._id,
      })
      .then((res) => {
        setGrade(res.data.grade);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getGrade();
  }, [enrollCourseData, maxScore]);

  const handleLessonComplete = () => {
    console.log("enrollCourseData:", enrollCourseData);
    console.log("token:", localStorage.getItem("token"));
    debugger;
    let secInd = sectionIndex;
    let lessInd = lessonIndex;
    setLoadingBtn(true);

    if (lessonIndex + 1 < courseData.courseContent[sectionIndex].sectionLessons.length) {
      lessInd = lessInd + 1;
    } else if (lessonIndex + 1 === courseData.courseContent[sectionIndex].sectionLessons.length) {
      if (sectionIndex + 1 < courseData.courseContent.length) {
        secInd = secInd + 1;
        lessInd = 0;
      } else if (sectionIndex + 1 === courseData.courseContent.length) {
        secInd = sectionIndex;
      }
    }

    const body = {
      token: localStorage.getItem("token"),
      enrollmentID: enrollCourseData._id,
      sectionIndex: secInd,
      lessonIndex: lessInd,
    };

    const isLastLesson =
      sectionIndex + 1 >= courseData.courseContent.length &&
      lessonIndex + 1 >= courseData.courseContent[sectionIndex].sectionLessons.length;

    if (isLastLesson) {
      axios
        .post(process.env.REACT_APP_BACKEND_URL + "/api/enrollment/markAsCompleted", {
          token: localStorage.getItem("token"),
          enrollmentID: enrollCourseData._id,
          rating: ratings,
          feedback,
        })
        .then((res) => {
          if (res.data.error === false) {
            toast.success(res.data.message);
            setLoadingBtn(false);
            setPlaying(false);
            setQuizBtn(false);
            setNextBtn(false);
            setOpen(false);
            setRatings(0);
            setRated(false);
            setFeedback("");
          } else {
            toast.warn(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    } else {
      axios
        .post(process.env.REACT_APP_BACKEND_URL + "/api/enrollment/updateProgress", body)
        .then((res) => {
          if (res.data.error === false) {
            toast.success(res.data.message);
            setEnrollCourseData(res.data.data);
            setSectionIndex(res.data.data.sectionIndex);
            setLessonIndex(res.data.data.lessonIndex);
            setLoadingBtn(false);
            setPlaying(false);
            setQuizBtn(false);
            setNextBtn(false);
            setOpen(false);
          } else {
            setLoadingBtn(false);
            toast.warn(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
          setLoadingBtn(false);
        });
    }
  };

  // ─── Video time tracking intervals ────────────────────────────────────────
  const TIMER = 10000;
  const TIMERC = 1000;

  useEffect(() => {
    const intervalC = setInterval(() => {
      const video = document.getElementById("mnp_video_player");
      if (video) {
        setCurrentTime(video.currentTime);
        setDuration(video.duration);
      }
    }, TIMERC);

    const interval = setInterval(() => {
      const video = document.getElementById("mnp_video_player");
      if (video) {
        const min = Math.floor(video.currentTime / 60);
        const sec = Math.floor(video.currentTime - min * 60);
        setMinute(min);
        setSecond(sec);
      }
    }, TIMER);

    return () => {
      clearInterval(interval);
      clearInterval(intervalC);
    };
  }, []);

  useEffect(() => {
    if (firstTime && document.getElementById("mnp_video_player")) {
      document.getElementById("mnp_video_player").currentTime =
        minute !== null && second !== null ? minute * 60 + second : 0;
      setFirstTime(false);
    }
    if (
      second !== null &&
      minute !== null &&
      localStorage.getItem("token") &&
      enrollCourseData &&
      enrollCourseData._id
    ) {
      const LINK =
        process.env.REACT_APP_BACKEND_URL +
        "/api/enrollment/updateTime?minute=" +
        minute +
        "&second=" +
        second +
        "&token=" +
        localStorage.getItem("token") +
        "&enrollmentID=" +
        enrollCourseData._id;
      axios.get(LINK).catch((err) => console.log(err));
    }
  }, [second, minute]);

  useEffect(() => {
    setTimeout(() => {
      setTimerRun(true);
    }, 5000);
  }, []);

  // ─── Shared video element props ────────────────────────────────────────────
  const videoProps = {
    width: "100%",
    height: "100%",
    id: "mnp_video_player",
    controlsList: "noplaybackrate nodownload",
    ref: videoRef,
    src: courseData?.courseContent[sectionIndex]?.sectionLessons[lessonIndex]?.lessonVideo,
    poster: courseData?.courseContent[sectionIndex]?.sectionLessons[lessonIndex]?.lessonThumbnail,
    onEnded: handleVideoEnded,
    onPlaying: () => setPlaying(true),
    onPlay: () => setPlaying(true),
    onPause: () => setPlaying(false),
    onDoubleClick: openFullScreen,
    onClick: () => {
      setPlaying(!playing);
      playing ? videoRef.current.pause() : videoRef.current.play();
    },
  };

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      {!loading ? (
        <div className="UserCoursePlayer">
          {/* ── Mobile layout ── */}
          {windowDimensions.width <= 550 ? (
            <div className="UserCoursePlayer__videoPlayer__box__mob">
              <div
                className="UserCoursePlayer__videoPlayer__box"
                onMouseEnter={() => setPause(true)}
                onMouseLeave={() => setPause(false)}
                onDoubleClick={openFullScreen}
              >
                <video {...videoProps}>{" "}</video>
                {playing ? (
                  <div
                    className="UserCoursePlayer__videoPlayer__hover"
                    onDoubleClick={openFullScreen}
                    onClick={() => { videoRef.current.pause(); setPlaying(false); }}
                  >
                    <div className="UserCoursePlayer__videoPlayer__hover__top" />
                    <div
                      onDoubleClick={openFullScreen}
                      onClick={() => { videoRef.current.pause(); setPlaying(false); }}
                      className="UserCoursePlayer__videoPlayer__hover__center"
                    />
                    <div className="UserCoursePlayer__videoPlayer__hover__bottom">
                      <div onClick={openFullScreen} className="UserCoursePlayer__videoPlayer__hover__bottom__icon">
                        <FullscreenIcon fontSize="large" sx={{ color: "#FA8128" }} />
                      </div>
                    </div>
                  </div>
                ) : (
                  <div
                    onDoubleClick={openFullScreen}
                    onClick={() => { videoRef.current.play(); setPause(false); setPlaying(true); }}
                    className="UserCoursePlayer__videoPlayer__hover__pause"
                  >
                    <PlayArrowIcon className="UserCoursePlayer__videoPlayer__hover__btn" sx={{ color: "#41424C", fontSize: "50px" }} />
                  </div>
                )}
              </div>
              <div className="UserCoursePlayer__heading">
                {courseData?.courseContent[sectionIndex]?.sectionLessons[lessonIndex].lessonName}
              </div>
              <div className="UserCoursePlayer__leftSec__btn__box">
                {nextBtn && !quizBtn ? (
                  <LoadingButton
                    sx={{ color: "#FA8128", borderColor: "#FA8128", "&:hover": { backgroundColor: "#FA8128", color: "#41424C", borderColor: "#FA8128" }, "&:active": { backgroundColor: "#FA8128" } }}
                    loading={loadingBtn}
                    variant="outlined"
                    onClick={handleLessonComplete}
                  >
                    Next
                  </LoadingButton>
                ) : quizBtn && !open ? (
                  <Button
                    sx={{ color: "#FA8128", borderColor: "#FA8128", "&:hover": { backgroundColor: "#FA8128", color: "#41424C", borderColor: "#FA8128" }, "&:active": { backgroundColor: "#FA8128" } }}
                    variant="outlined"
                    onClick={() => setOpen(true)}
                  >
                    {openResult ? "Result" : "Retake Quiz"}
                  </Button>
                ) : null}
              </div>
            </div>
          ) : null}

          <div className="UserCoursePlayer__leftRight__container">
            {/* ── Sidebar ── */}
            <div className="UserCoursePlayer__rightSec">
              <div className="UserCoursePlayer__box">
                <CourseSections
                  sections={courseData?.courseContent}
                  setSectionIndex={setSectionIndex}
                  setLessonIndex={setLessonIndex}
                  setNextBtn={setNextBtn}
                  setQuizBtn={setQuizBtn}
                  setOpen={setOpen}
                  setOpenResult={setOpenResult}
                  setPlaying={setPlaying}
                  setQuizValue={setQuizValue}
                  setQuizResult={setQuizResult}
                  sectionIndex={sectionIndex}
                  lessonIndex={lessonIndex}
                  enrollCourseData={enrollCourseData}
                  videoRef={videoRef}
                />
              </div>
            </div>

            {/* ── Main content ── */}
            <div className="UserCoursePlayer__leftSec">
              {windowDimensions.width > 550 ? (
                <>
                  <div className="UserCoursePlayer__heading">
                    {courseData?.courseContent[sectionIndex]?.sectionLessons[lessonIndex].lessonName}
                  </div>
                  <div
                    className="UserCoursePlayer__videoPlayer__box"
                    onMouseEnter={() => setPause(true)}
                    onMouseLeave={() => setPause(false)}
                    onDoubleClick={openFullScreen}
                  >
                    <video {...videoProps}>{" "}</video>
                    {pause && playing ? (
                      <div onDoubleClick={openFullScreen} className="UserCoursePlayer__videoPlayer__hover">
                        <div className="UserCoursePlayer__videoPlayer__hover__top" />
                        <div
                          onDoubleClick={openFullScreen}
                          onClick={() => { videoRef.current.pause(); setPlaying(false); }}
                          className="UserCoursePlayer__videoPlayer__hover__center"
                        >
                          <PauseIcon
                            onClick={() => { videoRef.current.pause(); setPlaying(false); }}
                            className="UserCoursePlayer__videoPlayer__hover__btn"
                            sx={{ color: "#41424C", fontSize: "70px" }}
                          />
                        </div>
                        <div className="UserCoursePlayer__videoPlayer__hover__bottom">
                          <div className="UserCoursePlayer__videoPlayer__hover__bottom__icon">
                            <div onClick={() => { videoRef.current.pause(); setPlaying(false); }}>
                              <PauseIcon fontSize="large" sx={{ color: "#FA8128" }} />
                            </div>
                            <div onClick={() => handleBackward(5)}>
                              <Replay5Icon fontSize="large" sx={{ color: "#FA8128" }} />
                            </div>
                            <div onClick={() => handleBackward(10)}>
                              <Replay10Icon fontSize="large" sx={{ color: "#FA8128" }} />
                            </div>
                            <div onClick={() => handleBackward(30)}>
                              <Replay30Icon fontSize="large" sx={{ color: "#FA8128" }} />
                            </div>
                          </div>
                          <div className="UserCoursePlayer__videoPlayer__hover__bottom__icon">
                            <div>
                              <span>{formatTime(currentTime)}</span> / <span>{formatTime(duration)}</span>
                            </div>
                            <div onClick={openFullScreen}>
                              <FullscreenIcon fontSize="large" sx={{ color: "#FA8128" }} />
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : !playing ? (
                      <div
                        onDoubleClick={openFullScreen}
                        onClick={() => { videoRef.current.play(); setPause(false); setPlaying(true); }}
                        className="UserCoursePlayer__videoPlayer__hover__pause"
                      >
                        <PlayArrowIcon className="UserCoursePlayer__videoPlayer__hover__btn" sx={{ color: "#41424C", fontSize: "70px" }} />
                      </div>
                    ) : null}
                  </div>
                </>
              ) : null}

              <div className="UserCoursePlayer__leftSec__description__box">
                <div className="UserCoursePlayer__leftSec__btn__box">
                  {nextBtn && !quizBtn ? (
                    <LoadingButton
                      sx={{ color: "#FA8128", borderColor: "#FA8128", "&:hover": { backgroundColor: "#FA8128", color: "#41424C", borderColor: "#FA8128" }, "&:active": { backgroundColor: "#FA8128" } }}
                      loading={loadingBtn}
                      variant="outlined"
                      onClick={handleLessonComplete}
                    >
                      Next
                    </LoadingButton>
                  ) : quizBtn && !open ? (
                    <Button
                      sx={{ color: "#FA8128", borderColor: "#FA8128", "&:hover": { backgroundColor: "#FA8128", color: "#41424C", borderColor: "#FA8128" }, "&:active": { backgroundColor: "#FA8128" } }}
                      variant="outlined"
                      onClick={() => setOpen(true)}
                    >
                      {openResult ? "Result" : "Retake Quiz"}
                    </Button>
                  ) : null}
                </div>
                <div className="UserCoursePlayer__leftSec__description__heading">
                  {courseData?.courseName}
                </div>
                {windowDimensions.width <= 550 ? (
                  <div className="UserCoursePlayer__leftSec__description__box __mob">
                    <div className="UserCoursePlayer__instr__box__mob">
                      <div className="UserCoursePlayer__heading__mob">Instructor:</div>
                      <div className="UserCoursePlayer__instr__name__mob">{courseData.courseInstructor}</div>
                    </div>
                    <div className="UserCoursePlayer__abstract__box__mob">
                      <div className="UserCoursePlayer__heading__mob">Abstract</div>
                      <div className="UserCoursePlayer__abstract__mob">
                        <LongText content={courseData.courseAbstract} limit={70} />
                      </div>
                    </div>
                    <div className="UserCoursePlayer__abstract__box__mob">
                      <div className="UserCoursePlayer__heading__mob">FAQs</div>
                      <div className="UserCoursePlayer__abstract__mob">FAQS</div>
                    </div>
                  </div>
                ) : (
                  <CourseLesson courseData={courseData} />
                )}
              </div>
            </div>
          </div>

          {/* ── Quiz / Result Modal ── */}
          {open && (
            <Modal
              open={open}
              // No onClose — user cannot dismiss by clicking outside
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style} className="UserCoursePlayer__quiz__box">
                {!openResult ? (
                  <>
                    <div className="UserCoursePlayer__quiz__heading">
                      {indQuizToggler ? "Quiz (During Video)" : "Quiz"}
                    </div>
                    <div className="UserCoursePlayer__quiz__ques__container">
                      {questionsArr?.map((cur, ind) => (
                        <div key={ind} className="UserCoursePlayer__quiz__ques__box">
                          <div className="UserCoursePlayer__quiz__ques">
                            Q{ind + 1}) {cur.question}
                          </div>
                          <div className="UserCoursePlayer__quiz__ans__opt">
                            <div>Answers</div>
                            <FormControl>
                              <RadioGroup
                                aria-labelledby="demo-controlled-radio-buttons-group"
                                name={`quiz-question-${ind}`}
                                value={quizValue.find((item) => item?.question === cur?.question)?.myAnswer || ""}
                                onChange={(e) => handleQuizChange(e, ind, cur)}
                              >
                                {cur.answerOptions?.map((curSub, subInd) => (
                                  <React.Fragment key={subInd}>
                                    <FormControlLabel
                                      value={curSub?.option1}
                                      control={<Radio sx={{ "&, &.Mui-checked": { color: "#FA8128" } }} />}
                                      label={curSub?.option1}
                                    />
                                    <FormControlLabel
                                      value={curSub?.option2}
                                      control={<Radio sx={{ "&, &.Mui-checked": { color: "#FA8128" } }} />}
                                      label={curSub?.option2}
                                    />
                                    {curSub?.option3 && (
                                      <FormControlLabel
                                        value={curSub?.option3}
                                        control={<Radio sx={{ "&, &.Mui-checked": { color: "#FA8128" } }} />}
                                        label={curSub?.option3}
                                      />
                                    )}
                                    {curSub?.option4 && (
                                      <FormControlLabel
                                        value={curSub?.option4}
                                        control={<Radio sx={{ "&, &.Mui-checked": { color: "#FA8128" } }} />}
                                        label={curSub?.option4}
                                      />
                                    )}
                                  </React.Fragment>
                                ))}
                              </RadioGroup>
                            </FormControl>
                          </div>
                        </div>
                      ))}

                      <div className="UserCoursePlayer__quiz__btn__box">
                        {/* No cancel button — user must answer all questions */}
                        <LoadingButton
                          sx={{ color: "#FA8128", borderColor: "#FA8128", "&:hover": { backgroundColor: "#FA8128", color: "#41424C", borderColor: "#FA8128" }, "&:active": { backgroundColor: "#FA8128" } }}
                          variant="outlined"
                          onClick={indQuizToggler ? handleIndQuizSubmit : handleQuizSubmit}
                          loading={loadingBtn}
                        >
                          Submit
                        </LoadingButton>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="UserCoursePlayer__quiz__heading">Result</div>
                    <div className="UserCoursePlayer__result__container">
                  

                      <div className="UserCoursePlayer__result__left">
  {questionsArr.length > 0 ? (
    questionsArr.map((cur, ind) => (
      <div key={ind} className="UserCoursePlayer__quiz__ques__box">
        <div className="UserCoursePlayer__quiz__ques">
          Q{ind + 1}) {cur.question}
        </div>
        <div className="UserCoursePlayer__result__left__ans">
          Ans) {cur.correctAnswer}
        </div>
      </div>
    ))
  ) : (
    <div>No quiz for this lesson.</div>
  )}
</div>
                      <div className="UserCoursePlayer__result__right">
                        <div>
                          <TaskAltIcon sx={{ fontSize: "100px", color: "#00A86B" }} />
                        </div>
                        <div className="UserCoursePlayer__result__right__score__box">
                          <div className="UserCoursePlayer__result__right__score">
                            Score {quizResult}%
                          </div>
                          <div className="UserCoursePlayer__result__right__score">
                            Section {sectionIndex + 1}
                          </div>
                          <div className="UserCoursePlayer__result__right__score">
                            Lesson {lessonIndex + 1}
                          </div>
                        </div>
                        <div className="UserCoursePlayer__feedback__container">
                          <span style={{ fontSize: "20px" }}>Your feedback is valuable for us!</span>
                          <Rating
                            name="ratings"
                            value={ratings}
                            onChange={(event, newValue) => {
                              setRatings(newValue);
                              setRated(true);
                            }}
                            size="large"
                            disabled={completed}
                          />
                          <TextField
                            fullWidth
                            id="outlined"
                            label="Feedback"
                            variant="outlined"
                            name="feedback"
                            autoComplete="off"
                            value={feedback}
                            multiline
                            rows={4}
                            onChange={(e) => setFeedback(e.target.value)}
                            disabled={completed}
                          />
                        </div>
                        {rated && completed && (
                          <div className="UserCoursePlayer__certifcate__box">
                            <div className="UserCoursePlayer__certificate__heading">
                              Do you want to download the Certificate?
                            </div>
                            {courseData.hasCertificate ? (
                              quizResult > 70 ? (
                                timerRun ? (
                                  <>
                                    <ReactToPrint
                                      trigger={() => (
                                        <div className="box__left__btn__color3">Download Certificate</div>
                                      )}
                                      content={() => PDFRef.current}
                                    />
                                    <div style={{ display: "none" }}>
                                      <PDFToPrint
                                        name={JSON.parse(localStorage.getItem("user"))?.name}
                                        course={courseData?.courseName}
                                        date={completedData?.completedDate}
                                        ref={PDFRef}
                                      />
                                    </div>
                                  </>
                                ) : (
                                  <div className="box__left__btn__color3">Generating Certificate...</div>
                                )
                              ) : (
                                <div
                                  className="box__left__btn__color3"
                                  onClick={() => {
                                    toast.info("Your quiz score is lower than 70%. Please retake the quizzes to gain a better score and get a certificate");
                                    setOpenCertificateModal(false);
                                  }}
                                >
                                  Low Quiz Score ({quizResult}%)
                                </div>
                              )
                            ) : (
                              <div><br />This course has no certification</div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="UserCoursePlayer__quiz__btn__box">
                      <Button
                        sx={{ color: "#FA8128", borderColor: "#FA8128", "&:hover": { backgroundColor: "#FA8128", color: "#41424C", borderColor: "#FA8128" }, "&:active": { backgroundColor: "#FA8128" } }}
                        variant="outlined"
                        onClick={() => setOpen(false)}
                      >
                        Close
                      </Button>
                      {!completed && (
                        <LoadingButton
                          sx={{ color: "#FA8128", borderColor: "#FA8128", "&:hover": { backgroundColor: "#FA8128", color: "#41424C", borderColor: "#FA8128" }, "&:active": { backgroundColor: "#FA8128" } }}
                          loading={loadingBtn}
                          variant="outlined"
                          onClick={handleLessonComplete}
                          disabled={!rated}
                        >
                          Next
                        </LoadingButton>
                      )}
                    </div>
                  </>
                )}
              </Box>
            </Modal>
          )}
        </div>
      ) : (
        <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
    </>
  );
};

export default UserCoursePlayer;